import React, { useEffect, useRef, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { img_placehlder } from "../../../../assets";
import { BsFillSendFill } from "react-icons/bs";
import { GoChevronRight } from "react-icons/go";
import { groupMemberListApi } from "../../../../services/groupMember";
import { toastMessage } from "../../../../utils/toastMessage";
import MemberListModal from "./MemberListModal";
import { useSelector } from "react-redux";
import { socket } from "../../../../utils/socket";
import { TextArea } from "../../../../components/header/form";
import { IoImage } from "react-icons/io5";
import FileUpload from "./FileUpload";
import { GiHamburgerMenu } from "react-icons/gi";
import { uploadAttachmentApi } from "../../../../services/message";
import ViewProfile from "./ViewProfile";
import RightSideMessage from "../groupMessages/RightSideMessage";
import LeftSideMessage from "../groupMessages/LeftSideMessage";
import { CiCircleRemove } from "react-icons/ci";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Lightbox from "yet-another-react-lightbox";
import { previewFiles, renderMessage } from "../groupMessages/commonMessage";
import MessageWithLink from "../groupMessages/MessageWithLink";
import FlatList from "components/FlatList";
import MessageLoading from "./MessageLoading";
import { groupBy } from "utils/commonHelper";
import { IoMdArrowDown } from "react-icons/io";

const GroupChat = ({
  chatMessage,
  setChatMessage,
  chatContainerRef,
  fetchMessages,
  selectedChat,
  currentPage,
  setCurrentPage,
  totalPages,
  showChatUsers,
  chatId,
  isReplay,
  setIsReplay,
  selectedReplyData,
  setSelectReplyData,
  attachment,
  setAttachment,
  inputData,
  setInputData,
}) => {
  const chatEndRef = useRef(null);
  const chatInputRef = useRef(null);
  const replyRef = useRef(null);
  const messageRefs = useRef({});
  const { showAuth } = useSelector((state) => state?.showAuth);
  const [highlightMsg, setHighlightMsg] = useState(false);

  const [memberList, setMemberList] = useState([]);
  const [memberListModal, setMemberListModal] = useState(false);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [file, setFile] = useState({ attachment: "" });
  const [imageModal, setImageModal] = useState(false);
  const [imageButtonLoader, setImageButtonLoader] = useState(false);
  const [viewProfileUrl, setViewProfileUrl] = useState("");
  const [viewProfileModal, setViewProfileModal] = useState(false);

  // Fetch group members
  const fetchGroupMemberList = async () => {
    try {
      const { data } = await groupMemberListApi({
        _id: selectedChat?._group?._id,
      });
      const { success, message, data: response, meta } = data;
      if (success) {
        setMemberList(response);
        setTotal(meta?.totalRecords || 0);
      } else {
        toastMessage(message, "error", "fetchGroupMemberList");
      }
    } catch (e) {
      console.error(e.message);
    }
  };

  useEffect(() => {
    if (selectedChat?._group?._id) fetchGroupMemberList();
  }, [selectedChat?._group?._id]);

  // Send message
  const sendDataHandler = (attachmentData) => {
    let sendData = {};
    const uploadedUrl = attachmentData?.attachment || "";
    const ext = uploadedUrl.split(".").pop().toLowerCase();
    const isImage = ["jpg", "jpeg", "png", "gif", "webp"].includes(ext);
    const isPDF = ext === "pdf";
    const hasMsg = inputData?.message?.trim();
    const hasAtt = attachmentData?.attachment;

    if (hasMsg && hasAtt) {
      sendData = {
        attachments: [
          {
            type: isImage ? "IMAGE" : isPDF ? "DOCUMENTS" : "UNKNOWN",
            url: uploadedUrl,
            name: attachmentData.name,
            size: attachmentData.size,
          },
        ],
        message: hasMsg,
        type: "BOTH",
      };
    } else if (!hasMsg && hasAtt) {
      sendData = {
        attachments: [
          {
            type: isImage ? "IMAGE" : isPDF ? "DOCUMENTS" : "UNKNOWN",
            url: uploadedUrl,
            name: attachmentData.name,
            size: attachmentData.size,
          },
        ],
        type: attachmentData.type || "MEDIA",
      };
    } else if (hasMsg) {
      sendData = { message: hasMsg, type: inputData.type || "TEXT" };
    }
    if (!Object.keys(sendData).length) {
      toastMessage("No data to send.", "error", "sendData");
      return;
    }

    socket.emit("SENT_MESSAGE", {
      _chat: chatId || selectedChat?._id,
      ...(isReplay ? { replyOf: selectedReplyData?._id } : {}),
      ...sendData,
    });
    setInputData({ message: "", type: "" });
    setAttachment({ attachment: "", type: "", url: "" });
    setFile({ attachment: "" });
    setIsReplay(false);
    setSelectReplyData({});
  };

  // Receive incoming
  useEffect(() => {
    const receiveMessage = ({ success, data: resp }) => {
      if (success) setChatMessage((prev) => [resp, ...prev]);
    };
    socket.on("RECEIVE_MESSAGE", receiveMessage);
    return () => socket.off("RECEIVE_MESSAGE", receiveMessage);
  }, []);

  const loadMore = () => {
    if (currentPage < totalPages) {
      fetchMessages(currentPage + 1);
      setCurrentPage((prev) => prev + 1);
    }
  };

  // Auto-scroll new
  const scrollBottom = (scroll = false) => {
    if (chatEndRef.current && (currentPage === 1 || scroll)) {
      chatEndRef.current.scrollIntoView({ behavior: "instant" });
    }
  };

  // Paste image handler
  useEffect(() => {
    const handlePaste = (e) => {
      for (let item of e.clipboardData.items) {
        if (item.type.startsWith("image/")) {
          const imgFile = item.getAsFile();
          setFile({ attachment: imgFile });
          uploadAttachment(e, imgFile);
          break;
        }
      }
    };
    document.addEventListener("paste", handlePaste);
    return () => document.removeEventListener("paste", handlePaste);
  }, []);

  // Upload attachment API call
  const uploadAttachment = async (e, file) => {
    if (!file)
      return toastMessage("Please upload an image", "error", "selectMedia");
    try {
      setImageButtonLoader(true);
      const formData = new FormData();
      formData.append("attachments", file);
      const { data } = await uploadAttachmentApi(formData);
      const { success, message, data: res } = data;
      if (success)
        setAttachment({
          attachment: res[0].key,
          url: res[0].url,
          type: "MEDIA",
          name: res[0].originalName,
          size: res[0].size,
        });
      toastMessage(message, success ? "success" : "error", "uploadAttachment");
    } catch (err) {
      console.error(err);
    } finally {
      setImageButtonLoader(false);
    }
  };

  //----------handle-view-profile-------------
  const handleViewProfile = (image) => {
    if (image) {
      setViewProfileUrl(image);
      setViewProfileModal(true);
    }
  };

  const scrollToMessage = (messageId) => {
    if (messageRefs.current[messageId]) {
      // Scroll to the message
      messageRefs.current[messageId]?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
      // Highlight the message
      const messageElement = messageRefs.current[messageId];
      messageElement.classList.add("highlight-message");
      setHighlightMsg(true);
      // Remove the highlight after 2 seconds
      setTimeout(() => {
        messageElement.classList.remove("highlight-message");
        setHighlightMsg(false);
      }, 2000);
    }
  };

  return (
    <div className="chatting">
      <div className="chat_wrapper">
        <div className="chat-header">
          <div className="responsive_menubar" onClick={showChatUsers}>
            <button>
              <GiHamburgerMenu />
            </button>
          </div>
          <div
            className="avatar"
            onClick={() => {
              if (selectedChat?._group?.coverImage) {
                setViewProfileUrl(selectedChat._group.coverImage);
                setViewProfileModal(true);
              }
            }}
          >
            <img
              src={selectedChat?._group?.coverImage || img_placehlder}
              alt="Group"
            />
          </div>
          <div className="text-content">
            <div className="title">{selectedChat?._group?.name}</div>
            <div className="memberss" onClick={() => setMemberListModal(true)}>
              {total > 10 ? "10+ Members" : `${total} Members`}{" "}
              <GoChevronRight className="memberss_arrow" />
            </div>
          </div>
        </div>

        <div
          id="group_chat_div"
          className="chat-messages"
          ref={chatContainerRef}
          style={{
            // height: 200,
            overflow: "auto",
            display: "flex",
            flexDirection: "column-reverse",
          }}
        >
          <InfiniteScroll
            dataLength={chatMessage.length}
            next={loadMore}
            hasMore={currentPage < totalPages}
            loader={<MessageLoading />}
            inverse
            scrollableTarget="group_chat_div"
            style={{
              overflow: "hidden",
              display: "flex",
              flexDirection: "column-reverse",
            }}
            scrollThreshold={0.8}
          >
            <div ref={chatEndRef} />

            <FlatList
              data={groupBy(chatMessage, "createdAt")}
              renderItem={({ date, data: messages }) => {
                return (
                  <React.Fragment key={date}>
                    <FlatList
                      data={messages}
                      waitForRender
                      loadingItem={(it) => <MessageLoading key={it} />}
                      renderItem={(data, ind) => {
                        return (
                          <div
                            key={data._id + ind}
                            ref={(el) => {
                              if (el) messageRefs.current[data._id] = el;
                            }}
                          >
                            {data?._sender?._id === showAuth?._id ? (
                              <RightSideMessage
                                {...{
                                  data,
                                  ind,
                                  handleViewProfile,
                                  scrollToMessage,
                                  highlightMsg,
                                  setIsReplay,
                                  setSelectReplyData,
                                }}
                              />
                            ) : (
                              <LeftSideMessage
                                {...{
                                  data,
                                  handleViewProfile,
                                  setIsReplay,
                                  setSelectReplyData,
                                  scrollToMessage,
                                  highlightMsg,
                                }}
                              />
                            )}
                          </div>
                        );
                      }}
                      onRenderComplete={scrollBottom}
                    />

                    <div className="date_wrap">
                      <p className="date">{date}</p>
                    </div>
                  </React.Fragment>
                );
              }}
            />
          </InfiniteScroll>
        </div>

        <button className="scroll_bottom" onClick={() => scrollBottom(true)}>
          <IoMdArrowDown />
        </button>
      </div>

      <div className="isReply img_reply">
        {imageButtonLoader ? (
          <p>Uploading...</p>
        ) : (
          <>
            {isReplay && (
              <>
                <button
                  type="button"
                  className="remove"
                  onClick={() => {
                    setIsReplay(false);
                    setSelectReplyData({});
                  }}
                >
                  <CiCircleRemove />
                </button>
                <div className="reply_text">
                  <b className="user_name">
                    {selectedReplyData?._sender?.fullName}
                  </b>
                  {selectedReplyData?.message && (
                    <p>{renderMessage(selectedReplyData)}</p>
                  )}
                  {selectedReplyData?.attachments?.length > 0 &&
                    previewFiles(selectedReplyData.attachments[0].url)}
                </div>
              </>
            )}

            {attachment?.url && (
              <div className="reply_text post_img">
                {previewFiles(attachment.url)}
              </div>
            )}

            <MessageWithLink message={inputData?.message} />
          </>
        )}
      </div>

      <div
        className="chat-input"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            sendDataHandler(attachment);
          } else if (e.key === "Enter" && e.shiftKey) {
            e.preventDefault();
            setInputData((prev) => ({ ...prev, message: prev.message + "\n" }));
          }
        }}
        ref={chatInputRef}
      >
        <TextArea
          ref={replyRef}
          disabled={imageButtonLoader}
          className="input-field"
          value={inputData.message || ""}
          placeholder={
            attachment.url ? "Add caption..." : "Write message here..."
          }
          name="message"
          onChange={(e) =>
            setInputData({ message: e.target.value, type: "TEXT" })
          }
        />
        <IoImage
          className="input_inside_img"
          onClick={() => setImageModal(true)}
        />
        <button
          className="send-button"
          disabled={
            (!inputData.message.trim() && !attachment.attachment) ||
            imageButtonLoader
          }
          onClick={() => sendDataHandler(attachment)}
        >
          <BsFillSendFill />
        </button>
      </div>

      <MemberListModal
        memberList={memberList}
        total={total}
        setPage={setPage}
        show={memberListModal}
        handleClose={() => setMemberListModal(false)}
      />

      <FileUpload
        show={imageModal}
        close={() => setImageModal(false)}
        attachment={attachment}
        setAttachment={setAttachment}
        file={file}
        setFile={setFile}
        sendDataHandler={sendDataHandler}
      />

      {/* <ViewProfile
        show={viewProfileModal}
        close={() => setViewProfileModal(false)}
        profileUrl={viewProfileUrl}
      /> */}

      <Lightbox
        className="chat_lightbox"
        open={viewProfileModal}
        plugins={[Zoom]}
        close={() => setViewProfileModal(false)}
        slides={[{ src: viewProfileUrl }]}
      />
    </div>
  );
};

export default GroupChat;
